import React, { Component } from "react";
import { Modal, ModalHeader, ModalBody, Row, Col } from "reactstrap";
import { Button } from "zina-dogi-react";
import { Formik, Form, Field } from "formik";
import AsyncSelect from "react-select/async";
import { service as vendorService } from "../../vendors";
import CircleLoader from "react-spinners/CircleLoader";

export default class QCModal extends Component {
    constructor(props) {
        super(props);
        this.data = null;
        this.state = {
            modal: false,
            contracts: [],
            loading_contract_report: false
        };
        this.toggle = this.toggle.bind(this);
    }

    toggle(qc_number = null) {
        this.setState({
            modal: !this.state.modal,
            contracts: []
        });
        if (qc_number) {
            vendorService.getContractLinesByContractNumber(qc_number).then(contracts => {
                this.setState({ contracts });
            });
        }
    }

    loadOptions = val => {
        return vendorService.getContractList(val).then(resp => {
            const res = resp.map(val => {
                return { value: val.id, label: val.number };
            });
            return res;
        });
    };

    downloadReport = () => {
        const contract = this.state.contracts[0].contract;
        this.setState({ loading_contract_report: true });
        return vendorService.contractReport(contract).then(resp => {
            this.setState({ loading_contract_report: false });
            return resp;
        });
    };

    onSubmit = (values, formik) => {
        if (values.search !== "") {
            vendorService.getContractLines(values.search.value).then(contracts => {
                this.setState({ contracts });
                formik.resetForm();
                formik.setSubmitting(false);
            });
        }
    };

    render() {
        const { contracts } = this.state;
        return (
            <div>
                <Modal isOpen={this.state.modal} toggle={this.toggle} size="xl" centered>
                    <ModalHeader>Search QC</ModalHeader>
                    <ModalBody>
                        <div>
                            <Formik className="qc-modal" initialValues={{ search: "" }} onSubmit={this.onSubmit}>
                                {formik => (
                                    <Form className="form">
                                        <div className="fields">
                                            <Row>
                                                <Col lg={6}>
                                                    <div className="form-group">
                                                        <label>Quantity Contract Number</label>
                                                        <Field
                                                            name="search"
                                                            value={formik.values.search}
                                                            component={AsyncSelect}
                                                            isClearable
                                                            cacheOptions
                                                            defaultOptions
                                                            loadOptions={this.loadOptions}
                                                            onChange={val => formik.setFieldValue("search", val, false)}
                                                        />
                                                    </div>
                                                </Col>
                                            </Row>
                                            <div className="row controls">
                                                <Button
                                                    type="submit"
                                                    color="primary"
                                                    style={{ width: "175px" }}
                                                    className="mr-1"
                                                >
                                                    Submit
                                                </Button>
                                                <Button
                                                    className="btn-danger mr-1"
                                                    onClick={this.toggle}
                                                    type="button"
                                                    name="Close"
                                                    style={{ width: "175px" }}
                                                >
                                                    Close
                                                </Button>
                                                {contracts && contracts.length > 0 && (
                                                    <React.Fragment>
                                                        <Button
                                                            color="primary"
                                                            type="button"
                                                            onClick={this.downloadReport}
                                                        >
                                                            Download
                                                        </Button>
                                                        {this.state.loading_contract_report && (
                                                            <CircleLoader
                                                                loading={this.state.loading_contract_report}
                                                                color={"#007bff"}
                                                            />
                                                        )}
                                                    </React.Fragment>
                                                )}
                                            </div>
                                        </div>
                                    </Form>
                                )}
                            </Formik>
                            <div className="tableFixHead">
                                <table className="table table-bordered table-striped">
                                    <thead className="table-dark">
                                        <tr>
                                            <th>Contract Number</th>
                                            <th>Item</th>
                                            <th>Material</th>
                                            <th>Description</th>
                                            <th>Customer Material Number</th>
                                            <th>Net Price</th>
                                            <th>Net Value</th>
                                            <th>Target Quantity</th>
                                            <th>Order Quantity</th>
                                            <th>Cancelled</th>
                                            <th>Balance</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {contracts &&
                                            contracts.length > 0 &&
                                            contracts.map(contract => {
                                                return (
                                                    <tr>
                                                        <td>{contract.contract.number}</td>
                                                        <td>{contract.item}</td>
                                                        <td>{contract.material}</td>
                                                        <td>{contract.description}</td>
                                                        <td>{contract.customer_material_number}</td>
                                                        <td>{contract.net_price}</td>
                                                        <td>{contract.net_value}</td>
                                                        <td>{contract.target_quantity}</td>
                                                        <td>{contract.order_quantity}</td>
                                                        <td>{contract.cancelled ? "Yes" : "No"}</td>
                                                        <td>{contract.balance}</td>
                                                    </tr>
                                                );
                                            })}
                                        {contracts && contracts.length === 0 && (
                                            <tr>
                                                <td colSpan={11}>No data Found</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </ModalBody>
                </Modal>
            </div>
        );
    }
}
